import { isNotDefined } from '@sgme/fp';

import { selectFlexiForwardTile } from '@/store/flexi-forward/selectors/tile.ts';
import type { FxFlexiForward } from '@/store/flexi-forward/state.ts';
import { createAppSelector } from '@/store/storeMethods.ts';

export interface FlexiForwardCurrency {
  currencyPair: string;
  currency1: string;
  currency2: string;
}

export const selectFlexiForwardCurrency = (flexiForward: FxFlexiForward): FlexiForwardCurrency => {
  const currencyPair = flexiForward.properties.currencyPair;
  if (isNotDefined(currencyPair)) {
    throw new Error(`Could not find currency pair on flexi forward with tileId ${flexiForward.properties.tileId}`);
  }

  const [currency1, currency2] = currencyPair.split('/');

  return {
    currencyPair,
    currency1: currency1 ?? '',
    currency2: currency2 ?? '',
  };
};

export const selectFlexiForwardCurrencyPair = (tileId: string) =>
  createAppSelector(
    (state) => selectFlexiForwardTile(state, tileId)?.properties.currencyPair,
    (currencyPair) => currencyPair,
  );
export const selectFlexiForwardClientsWay = (tileId: string) =>
  createAppSelector(
    (state) => selectFlexiForwardTile(state, tileId)?.properties.clientsWay,
    (clientsWay) => clientsWay,
  );
